module.exports = __webpack_public_path__ + "img/1024_gift.5b1c6c96.png";